import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { MastersuiteService } from './mastersuite.service';



@Injectable()
export class DetailsResolver implements Resolve<any>{
    constructor(private mastersuiteService: MastersuiteService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.mastersuiteService.getMastersuiteById(route.params.id);
    }
}
